<template>
  <v-app-bar
    color="bgdark"
    app
    height="80"
  >
    <div>
      <v-img src="https://cdn.123.net/img/123net-logo_new.svg" style="max-width: 126px; max-height: 50px;" />
    </div>
    <v-spacer></v-spacer>
    <v-btn
      color="third"
      class="white--text"
      :href="emailLink"
    >
      <v-icon class="mr-1">mdi-lifebuoy</v-icon>
      Need Help?
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'Navbar',
  computed: {
    emailLink() {
      const vm = this;
      return `mailto:${vm.$store.state.helpContact}?subject=Additional%20Information%20Assistance%20%5BContract%20ID%23%3A%20${vm.$store.state.contractId}%5D`;
    },
  },
};
</script>
